import ModalStack from '-/Custom/ModalStack';
import type { EventScorekeepingScoreFormValues } from '-/Event/EventScorekeeping/EventScorekeepingScore/EventScorekeepingScore.types';
import { useLocalSearchParams } from 'expo-router';
import { FormProvider, useForm } from 'react-hook-form';
import { useClient } from 'urql';
import { graphql } from '@/gql/graphql';

const GetEventScorekeepingScoreLayout = graphql(/* GraphQL */ `
  query GetEventScorekeepingScoreLayout($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      event_teams {
        event_id
        team_id
        score
      }
      status
    }
  }
`);

export default function EventScorekeepingScoreLayout() {
  const { eventId } = useLocalSearchParams<{ eventId?: string }>();
  const client = useClient();

  const form = useForm<EventScorekeepingScoreFormValues>({
    reValidateMode: 'onChange',
    defaultValues: async () => {
      const { data } = await client
        .query(GetEventScorekeepingScoreLayout, { eventId: eventId || '' })
        .toPromise();

      const formattedScores: { [key: string]: string } = (
        data?.event_by_pk?.event_teams || []
      ).reduce((acc: { [key: string]: string }, curr) => {
        acc[curr.team_id] = curr.score.toString();
        return acc;
      }, {});

      return { scores: formattedScores, status: data?.event_by_pk?.status };
    },
  });

  return (
    <FormProvider {...form}>
      <ModalStack />
    </FormProvider>
  );
}
